import { NavLink } from 'react-router';
import useLayoutPermission from '@src/hooks/useLayoutPermission';
import { ConfigFeature } from '@src/types/LayoutPermission';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';

const configNavItems: Array<{
  titleId: string;
  feature: ConfigFeature;
  link: string;
}> = [
  {
    titleId: 'Default Stack',
    feature: 'default-stack',
    link: 'default-stack',
  },
  {
    titleId: 'Calendar',
    feature: 'calendar',
    link: 'calendar',
  },
  {
    titleId: 'Calendar Stacks',
    feature: 'stack',
    link: 'stacks',
  },
  {
    titleId: 'Control Mode Templates',
    feature: 'modes',
    link: 'modes',
  },
  {
    titleId: 'Basic Control Modes',
    feature: 'basic-modes',
    link: 'basic-modes',
  },
  {
    titleId: 'Tesla Config',
    feature: 'tsc-config',
    link: 'tsc-config',
  },
];

interface TopBarProps {
  siteMeta: SiteMeta;
}

function TopBar({ siteMeta }: TopBarProps) {
  const { configFeatures } = useLayoutPermission();
  const isCalendarEnabled = siteMeta?.ui?.Home_Calendar_Enable !== false;

  // Filter items based on calendar enable flag
  const visibleItems = configNavItems.filter((item) => {
    // When calendar is disabled, only show Control Mode Templates and Default Stack

    if (!isCalendarEnabled) {
      return (
        item.feature === 'default-stack' ||
        item.feature === 'modes' ||
        item.feature === 'basic-modes'
      );
    }
    return true;
  });

  return (
    <div className='topbar'>
      <div className='frame'>
        {visibleItems.map(({ feature, titleId, link }) =>
          configFeatures.includes(feature) ? (
            <NavLink
              key={feature}
              to={`/home/config/${link}`}
              className={({ isActive }) => `link ${isActive ? 'active' : ''}`}
            >
              <FormattedAlias id={titleId} />
            </NavLink>
          ) : null,
        )}
      </div>
    </div>
  );
}

export default storeConnector(TopBar, {
  config: ['siteMeta'],
});
